module.exports = __webpack_public_path__ + "static/img/RW666_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW666_1.png
// module id = /RIS
// module chunks = 0